import { StyleSheet } from 'react-native';

import { colors, spacing, layout } from '../theme';

export const pageWrapperStyles = StyleSheet.create({
	container: {
		flex: 1,
		padding: spacing.m,
		backgroundColor: colors.background,
	},
	header: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: spacing.m,
	},
	backButtonContainer: {
		marginRight: spacing.m,
	},
	backButton: {
		padding: spacing.xs,
	},
	title: {
		flex: 1,
		fontWeight: '600',
	},
	divider: {
		marginBottom: spacing.m,
	},
	loadingContainer: {
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
	},
	errorContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		padding: spacing.m,
		backgroundColor: colors.primaryLight,
		borderRadius: layout.borderRadius.medium,
		marginBottom: spacing.m,
	},
	errorText: {
		marginLeft: spacing.xs,
		color: colors.error,
	},
});
